import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { connect } from 'react-redux';
import { Dropdown } from 'primereact/dropdown';
import { InputSwitch } from 'primereact/inputswitch';
import { Toast } from 'primereact/toast';
import { InputTextarea } from 'primereact/inputtextarea';
import Messages from '../../../shared/UI/Messages/Messages';

import { REDIRECT_TO_URL, HASACCESS } from '../../../shared/utility';
import { DROPDOWN_CONFIG, USER_SUBMENU_ID } from '../../../shared/Config';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import * as actions from '../../../store/actions/index';

class AddModifier extends Component {
    state = {
        type: 'add',
        Id: null,
        ModifierId: null,
        ModifierName: null,
        ModifierGroupId: '',
        extraPrice: '',
        KitchenInstruction: '',
        branch: '', 
        isActive: false,
        // createdBy: (this.props.loggedUserDetail?.userName) ?? 'Admin',
        // createdDate: new Date(),
        CompanyId: this.props.loggedUserDetail?.CompanyId || '',
        touch: false,
        // For dropdown options
        ModifierGroupOptions: [],
        dataFetched: false
    }

    componentDidMount() {

        this.getAccess = HASACCESS(USER_SUBMENU_ID);

        this.props.getMasterKeywordList("ModifierGroup");  // Fetches ModifierGroup data for dropdown

        const type = this.props.match.params.type;
        const id = this.props.match.params.id;

        this.setState({
            type
        });

        if (type !== "add") {
            this.fetchSingleProcess(id);
        }

    }

    // fetchSingleProcess = () => {
    //     let storeId = this.props.match.params.id;  // Using 'id' from params
    //     let companyId = this.props.loggedUserDetail?.CompanyId || Companyid;
    //     this.props.getMasterTableList(`res/GetInvStorebyid?storeid=${storeId}`, companyId);

    //     // Start timer to check when data is loaded
    //     this.startTimer();
    // }

    fetchSingleProcess = (id) => {

        this.props.getMasterTableList(
            `res/GetresModifierbyid?ModifierId=${id}`,
            this.state.CompanyId
        );

    }

    // startTimer = () => {
    //     this.intervalID = setInterval(() => {
    //         this.processFetchedData();
    //     }, 2000);
    // }

    // componentDidUpdate(prevProps) {
    //     // If tableLists changes and we haven't processed data yet
    //     if (this.props.tableLists !== prevProps.tableLists &&
    //         this.props.tableLists &&
    //         this.props.tableLists.length > 0 &&
    //         !this.state.dataFetched) {
    //         this.processFetchedData();
    //     }
    // }

    componentDidUpdate(prevProps) {

        if (
            this.props.tableLists &&
            this.props.tableLists !== prevProps.tableLists
        ) {

            const tableLists = this.props.tableLists;

            this.setState({

                Id: tableLists.ModifierId,

                ModifierId: tableLists.ModifierId,

                ModifierName: tableLists.ModifierName,

                ModifierGroupId: tableLists.ModifierGroupId,

                extraPrice: tableLists.extraPrice,

                KitchenInstruction: tableLists.KitchenInstruction,

                branch: tableLists.branch,

                CompanyId: tableLists.CompanyId,

                isActive: tableLists.isActive,

            });

        }

    }

    componentWillUnmount() {
        if (this.intervalID) {
            clearInterval(this.intervalID);
        }
    }
    processFetchedData = () => {
        // Check if store data is available
        if (this.props.tableLists && this.props.tableLists.length > 0) {
            clearInterval(this.intervalID);

            // Get the first item (assuming single record)
            const tableLists = this.props.tableLists[0] || this.props.tableLists;

            if (tableLists) {
                // Map the API response to your state properties
                this.setState({
                    Id: tableLists.ModifierId,
                    ModifierId: tableLists.ModifierId,
                    ModifierName: tableLists.ModifierName,
                    ModifierGroupId: tableLists.ModifierGroupId,
                    extraPrice: tableLists.extraPrice,
                    KitchenInstruction: tableLists.KitchenInstruction,
                    branch: tableLists.branch,
                    CompanyId: tableLists.CompanyId,
                    isActive: tableLists.isActive,
                    // isActive: storeData.isActive || false
                });
            }
        }
    }

    change = (e) => {
        let { name, value, checked, type } = e.target;

        // Handle different input types
        if (type === 'checkbox' || type === 'switch') {
            this.setState({ [name]: checked, touch: true });
        } else {
            this.setState({ [name]: value, touch: true });
        }
    }

    // Handle dropdown change
    onDropdownChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value, touch: true });
    }

    // Validate and save modifier
    add = () => {
        let type = this.props.match.params.type;

        // Validate required fields
        const errors = [];
        if (!this.state.ModifierName || this.state.ModifierName.trim() === '') {
            errors.push('Modifier Name is required');
        }
        if (!this.state.ModifierGroupId || this.state.ModifierGroupId.trim() === '') {
            errors.push('Modifier Group is required');
        }

        if (errors.length > 0) {
            errors.forEach(error => {
                this.growl.show({ severity: 'error', summary: 'Validation Error', detail: error });
            });
            return;
        }

        // Prepare data for API
        const data = {
            ModifierId: this.state.ModifierId,
            ModifierName: this.state.ModifierName.trim(),
            ModifierGroupId: this.state.ModifierGroupId,
            extraPrice: this.state.extraPrice,
            KitchenInstruction: this.state.KitchenInstruction,
            branchId: this.state.branch,
            isActive: this.state.isActive,
            CompanyId: this.state.CompanyId,
            // CreatedBy: this.state.createdBy,
            // CreatedDate: this.state.createdDate
        };

        // Add ID if editing
        if (type === 'edit' && this.state.Id) {
            data.Id = this.state.Id;
            data.ModifierId = this.state.ModifierId;
        }


        // Submit data - using 'Store' model and appropriate endpoint
        this.props.processDynamicData('Modifier', type, data, 'res/GetresModifierbyid?ModifierId=' + this.state.ModifierId);
    }

    resetData = () => {
        this.setState({
            Id: null,
            ModifierId: null,
            ModifierName: '',
            ModifierGroupId: '',
            extraPrice: '',
            KitchenInstruction: '',
            branch: '',
            isActive: false,
            type: 'add',
            touch: false,
            dataFetched: false
        });
    }

    render() {
        // Redirect on success
        if (this.props.success) {
            REDIRECT_TO_URL('/modifier/', this.props);
        }

        // Check access permissions
        let addAccess = true;
        let editAccess = true;
        if (this.getAccess !== undefined) {
            if (this.getAccess.viewAccess === false) {
                this.props.history.push('/dashboard');
            }
            addAccess = this.getAccess.addAccess === true;
            editAccess = this.getAccess.editAccess === true;
        }
        let accessButton = { addAccess, editAccess };

        // Prepare branch dropdown options - FIXED
        // let branchOptions = [];
        // if (this.props.branch && Array.isArray(this.props.branch)) {
        //     branchOptions = this.props.branch.map(branch => ({
        //         label: branch.branchName || branch.name || branch,
        //         value: branch.branch || branch.id || branch.branch || branch
        //     }));
        // } else if (this.state.branch) {
        //     // If no options loaded but we have a value, add it as a fallback
        //     branchOptions = [{ label: this.state.branch, value: this.state.branch }];
        // }

        let isEnabled = this.state.touch === true;
        let redirectURL = '/modifier/';

        return (
            <div className="p-grid">
                {this.props.loading && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                {this.props.success !== null && <Messages type="success" message={this.props.success} />}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>{this.state.type === 'edit' ? 'Edit' : this.state.type === 'view' ? 'View' : 'Add'} Modifier</h1>

                        <div className="p-grid mt1">
                            <div className="p-col-6 p-offset-3">
                                {/* Branch Dropdown */}

                                {/* Store Name */}
                                <div className="p-col-12">
                                    <label htmlFor="ModifierName">Modifier Name <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12">
                                    <InputText
                                        className="p-col-12"
                                        name="ModifierName"
                                        placeholder="Enter Modifier Name"
                                        value={this.state.ModifierName}
                                        onChange={this.change}
                                        disabled={this.state.type === 'view'}
                                    />
                                </div>
                                <div className="p-col-12">
                                    <label htmlFor="ModifierGroup">Modifier Group <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12">
                                    <Dropdown
                                        className="p-col-12"
                                        placeholder="Select Modifier Group"
                                        options={this.props.ModifierGroup}  // Use the mapped options
                                        value={this.state.ModifierGroup}
                                        name="ModifierGroup"
                                        onChange={this.onDropdownChange}
                                        {...DROPDOWN_CONFIG}
                                        disabled={this.state.type === 'view'}
                                    />
                                </div>
                                {/* Extra Price */}
                                <div className="p-col-12">
                                    <label htmlFor="extraPrice"> Extra Price <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12">
                                    <InputText
                                        className="p-col-12"
                                        name="extraPrice"
                                        placeholder="Enter Extra Price"
                                        value={this.state.extraPrice}
                                        onChange={this.change}
                                        disabled={this.state.type === 'view'}
                                    />
                                </div>


                                {/* Customer Number */}
                                <div className="p-col-12">
                                    <label htmlFor="KitchenInstruction">Kitchen Instruction</label>
                                </div>
                                <div className="p-col-12">
                                    <InputTextarea
                                        className="p-col-12"
                                        name="KitchenInstruction"
                                        placeholder="Enter Kitchen Instruction"
                                        value={this.state.KitchenInstruction}
                                        onChange={this.change}
                                        disabled={this.state.type === 'view'}
                                    />
                                </div>

                                {/* Mobile Number */}
                                {/* <div className="p-col-12">
                                    <label htmlFor="mobileNumber">Mobile Number</label>
                                </div>
                                <div className="p-col-12">
                                    <InputText
                                        className="p-col-12"
                                        name="mobileNumber"
                                        placeholder="Enter Mobile Number"
                                        value={this.state.mobileNumber}
                                        onChange={this.change}
                                        disabled={this.state.type === 'view'}
                                    />
                                </div> */}

                                {/* Email */}
                                {/* <div className="p-col-12">
                                    <label htmlFor="email">Email</label>
                                </div>
                                <div className="p-col-12">
                                    <InputText
                                        className="p-col-12"
                                        name="email"
                                        placeholder="Enter Email"
                                        value={this.state.email}
                                        onChange={this.change}
                                        disabled={this.state.type === 'view'}
                                    />
                                </div> */}

                                {/* Address */}
                                {/* <div className="p-col-12">
                                    <label htmlFor="address">Address</label>
                                </div>
                                <div className="p-col-12">
                                    <InputText
                                        className="p-col-12"
                                        name="address"
                                        placeholder="Enter Address"
                                        value={this.state.address}
                                        onChange={this.change}
                                        disabled={this.state.type === 'view'}
                                    />
                                </div> */}

                                {/* City */}
                                {/* <div className="p-col-12">
                                    <label htmlFor="city">City</label>
                                </div>
                                <div className="p-col-12">
                                    <InputText
                                        className="p-col-12"
                                        name="city"
                                        placeholder="Enter City"
                                        value={this.state.city}
                                        onChange={this.change}
                                        disabled={this.state.type === 'view'}
                                    />
                                </div> */}

                                {/* State */}
                                {/* <div className="p-col-12">
                                    <label htmlFor="state">State</label>
                                </div>
                                <div className="p-col-12">
                                    <InputText
                                        className="p-col-12"
                                        name="state"
                                        placeholder="Enter State"
                                        value={this.state.state}
                                        onChange={this.change}
                                        disabled={this.state.type === 'view'}
                                    />
                                </div> */}

                                {/* Pincode */}
                                {/* <div className="p-col-12">
                                    <label htmlFor="pincode">Pincode</label>
                                </div>
                                <div className="p-col-12">
                                    <InputText
                                        className="p-col-12"
                                        name="pincode"
                                        placeholder="Enter Pincode"
                                        value={this.state.pincode}
                                        onChange={this.change}
                                        disabled={this.state.type === 'view'}
                                    />
                                </div> */}

                                {/* Status Switch */}
                                <div className="p-col-12">
                                    <label htmlFor="isActive">Status</label>
                                </div>
                                <div className="p-col-12">
                                    <InputSwitch
                                        checked={this.state.isActive}
                                        onChange={this.change}
                                        name="isActive"
                                        value={this.state.isActive}
                                        disabled={this.state.type === 'view'}
                                    />
                                </div>
                            </div>

                            <div className="p-col-12 p-lg-12">
                                <FooterButton
                                    access={accessButton}
                                    disabled={!isEnabled || this.state.type === 'view'}
                                    type={this.state.type.toLowerCase()}
                                    save={this.add}
                                    reset={this.resetData}
                                    to={redirectURL}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        loggedUserDetail: state.auth.userObject,
        userDetail: state.auth.userDetail,
        userPref: state.auth.userPref,
        loading: state.master.loading,
        error: state.master.error,
        success: state.master.success,
        tableLists: state.master.tableLists,
        branch: state.keyword.Branch
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getMasterTableList: (table, companyid) => dispatch(actions.getMasterTableList(table, companyid)),
        getMasterKeywordList: (value) => dispatch(actions.getMasterKeywordList(value)),
        fetchRelavantLists: (value) => dispatch(actions.fetchRelavantLists(value)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddModifier);